var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"custom-box",class:( _obj = {}, _obj[_vm.align] = _vm.align, _obj['space-bottom'] =  _vm.spaceBottom, _obj['mini-space-bottom'] =  _vm.miniSpaceBottom, _obj['mini-padding'] =  _vm.miniPadding, _obj ),on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }